import { CustomPropertyType, PropertyValueType } from "operations/schema/schema";
import { IntlShape } from "react-intl";
import { intlFormatDate } from "./date";

export const formatCustomProperty = function (
  intl: IntlShape,
  property: CustomPropertyType,
  properties: PropertyValueType[],
) {
  const selectedProp = properties.find((p) => p.code === property.code);
  if (!selectedProp) return property.value;

  switch (selectedProp.dataType) {
    case "Date":
    case "D":
      if (property.value) return intlFormatDate(intl, property.value);
  }
  return property.value;
};
